export const BRAND = {
  companyName: 'Tidy Company',
  adminTitle: 'Tidy Admin',
  tagline: 'Clean homes. Cleaner offices. Done right.',
  headquarters: 'Oceanside, California',
  websiteUrl: 'https://unique-bublanina-222180.netlify.app',
};

export const SERVICE_AREAS = {
  direct: {
    label: 'North County San Diego',
    description: 'In-house team — directly employed cleaners',
    cities: [
      'Oceanside',
      'Carlsbad',
      'Vista',
      'San Marcos',
      'Encinitas',
      'Escondido',
      'Solana Beach',
      'Del Mar',
      'Rancho Santa Fe',
    ],
  },
  partner: {
    label: 'Partner markets',
    description: 'Vetted local partners — insured, bonded, and reviewed',
    metros: [
      'Phoenix',
      'Las Vegas',
      'Dallas',
      'Houston',
      'Austin',
      'Miami',
      'Atlanta',
      'Charlotte',
      'Raleigh',
    ],
  },
};
